module.exports = __webpack_public_path__ + "img/envelope_success.38815b08.svg";